import { throttle } from 'throttle-debounce';

/** Selector for any instance of this _Friendation_ component */
const selector = '[is="hero-media-big"]';

/**
 * Friendation component
 */
export const heroMediaBig = () => {
  /** Instances of this Friendation component */
  const components: HTMLElement[] = Array.from(
    document.querySelectorAll(selector)
  );

  components.forEach((component) => {
    const video: HTMLVideoElement | null = component.querySelector('video');
    const playButton: HTMLButtonElement | null =
      component.querySelector('.video-player');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const overlay: HTMLElement | null =
      component.querySelector('.video-overlay');

    if (!video || !playButton || !overlay) {
      return;
    }

    // handle the video play/pause functionality

    const handleVideo = (autoplay: boolean) => {
      if (autoplay) {
        playButton.classList.add('is--playing');
      }

      playButton.addEventListener('click', () => {
        if (video.paused) {
          video.play();
          playButton.classList.add('is--playing');
          overlay.style.display = 'none';
        } else {
          video.pause();
          playButton.classList.remove('is--playing');
        }
      });
    };

    // handle the video autoplay functionality based on user preferences reduce motion

    const handleReduceMotion = throttle(300, () => {
      if (reduceMotion.matches) {
        video.removeAttribute('autoplay');
        video.pause();
        playButton.dataset.visible = 'true';

        handleVideo(false);
      } else {
        video.setAttribute('autoplay', '');
        video.play();
        playButton.dataset.visible = 'false';
        handleVideo(true);
      }
    });

    window.addEventListener('change', handleReduceMotion);
    handleReduceMotion();
  });
};
